import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./Chemical.css";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";

const Chemical = () => {
  return (
    <>
      <Navbar />
      <div className="chemical-container">
        <h1 className="chemical-heading">Chemicals by Newbell Group​</h1>
        <p className="chemical-text">
          We are a well-established distribution organization handling various
          specialty chemicals, polymers, commodities, and additives.
        </p>
        <p className="chemical-text">
          We understand customer needs across diverse industry segments, such as
          Water treatment, Pulp & Paper, Chemicals, Pharma, Detergents, Food,
          feed etc.
        </p>
        <p className="chemical-text">
          We don’t just supply products; we deliver trust and customer delight.
        </p>
        <p className="chemical-text">
          GTM and Newbell believes that creative minds usher the future. We
          provide an ideal platform for creative talents to learn and grow their
          skills. A place where everyone can experience the chemistry of
          relationships whether it is customers or internal stakeholders.
        </p>
      </div>
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default Chemical;
